import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";
// import MobileNav from "./Components/MobileNav/MobileNav";
import Login from "./Pages/LoginPage/Login";
import LandingPage from "./Pages/LandingPage/LandingPage";
import ExpertView from "./Pages/ExpertView/ExpertView";
import Publisher from "./Pages/Publisher/Publisher";
import MyView from "./Pages/MyView/MyView";
import ProtectedRoute from "./guards/ProtectedRoute";
import GuestRoute from "./guards/GuestRoute";

function Layout() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Outlet />
      {/* {!hideNavbar && <MobileNav />} */}
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [

      // ── PUBLIC ──
      // Anyone can visit the landing page
      { path: "/", element: <LandingPage /> },

      // ── GUEST ONLY ──
      // Logged-in users are redirected away from /login
      {
        element: <GuestRoute />,
        children: [
          { path: "/login", element: <Login /> },
        ],
      },

      // ── PROTECTED ──
      // Must be logged in; otherwise redirected to /login
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/expertview", element: <ExpertView /> },
          { path: "/MyView",     element: <MyView /> },
          { path: "/publisher",  element: <Publisher /> },
        ],
      },

      // ── CATCH-ALL ──
      {
        path: "*",
        element: <Navigate to={localStorage.getItem("token") ? "/MyView" : "/"} replace />,
      },

    ],
  },
]);

export default router;
